import { useMutation, useQueryCache } from 'react-query';
import { VideoSubmissionAPI } from 'api/videoSubmission';
import { VIDEO_SUBMISSIONS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateVideoSubmission() {
  const queryCache = useQueryCache();

  return useMutation(VideoSubmissionAPI.addVideoSubmission, {
    onSuccess: ({ message }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(VIDEO_SUBMISSIONS);
    },
  });
}
